import { useEffect, useRef } from 'react'
import { MergeView } from '@codemirror/merge'
import classes from './MergeEditor.module.css'
import { EditorState } from '@codemirror/state'
import { EditorView } from '@codemirror/view'

const MergeEditor = ({ left, right }: { left: string; right: string }) => {
  const containerRef = useRef<HTMLDivElement | null>(null)
  const viewRef = useRef<MergeView | null>(null)

  useEffect(() => {
    if (!containerRef.current) return
    const view = new MergeView({
      a: { doc: left, extensions: [EditorState.readOnly.of(true), EditorView.lineWrapping] },
      b: { doc: right, extensions: [EditorState.readOnly.of(true), EditorView.lineWrapping] },
      parent: containerRef.current,
      highlightChanges: true,
      gutter: true,
    })
    viewRef.current = view
    return () => {
      view.destroy()
      viewRef.current = null
    }
  }, [left, right])

  return <div ref={containerRef} className={classes.root} />
}

export default MergeEditor
